<template>
  <v-container grid-list-lg>
    <h3>{{ $t("settings.product_settings") }}</h3>
    <!----------------------------------------Default Lotto---------------------------------------->
    <v-row class="mt-2">
      <v-col xs="6" md="6" lg="6">
        <v-select
          v-model="general.defaultShipment"
          :items="shipments"
          color="red-darken-3"
          item-title="name"
          item-value="_id"
          outlined
          :label="$t('settings.default_shipment')"
        />
      </v-col>
    </v-row>
    <!---------------------------------------Default Quality--------------------------------------->
    <v-row row>
      <v-col xs="6" md="6" lg="6">
        <v-select
          v-model="general.defaultQuality"
          :items="qualities"
          color="red-darken-3"
          item-title="value"
          item-value="_id"
          outlined
          :label="$t('settings.default_quality')"
        />
      </v-col>
    </v-row>
    <!--------------------------------------Default Warranty--------------------------------------->
    <v-row row>
      <v-col xs="6" md="6" lg="6">
        <v-select
          v-model="general.defaultWarranty"
          :items="warranties"
          color="red-darken-3"
          item-title="title"
          item-value="_id"
          outlined
          :label="$t('settings.default_warranty')"
        />
      </v-col>
    </v-row>
    <!----------------------------------------Default Price---------------------------------------->
    <v-row row>
      <v-col xs="6" md="6" lg="6">
        <v-text-field
          v-model="general.defaultPrice"
          color="red-darken-3"
          :label="$t('settings.default_price')"
          type="number"
          min="min"
          outlined
        />
      </v-col>
    </v-row>
    <!----------------------------------------Enable Weight---------------------------------------->
    <h3>{{ $t("settings.weight") }}</h3>
    <v-switch
      v-model="displayFeatures.partWeight"
      :label="$t('settings.enable_weight')"
      color="red-darken-3"
    />
    <!------------------------------Enable Images Background Removal-------------------------------
    <h3> {{ $t('settings.remove_background') }} </h3>
    <v-switch
      v-model="displayFeatures.removeImagesBackground"
      :label="$t('settings.enable_remove_background')"
      color="red-darken-3"
    />
    -->
  </v-container>
</template>

<script>
import getRequest from "../../api/getRequest";

export default {
  name: "Products",
  props: ["institution"], // eslint-disable-line vue/require-prop-types
  data() {
    return {
      shipments: [],
      qualities: [],
      warranties: [],
    };
  },
  computed: {
    general() {
      return this.$props.institution.preferences.general || {};
    },
    displayFeatures() {
      return this.$props.institution.preferences.displayFeatures || {};
    },
  },
  beforeMount() {
    this.getShipments();
    this.getQualities();
    this.getWarranties();
  },
  methods: {
    getShipments() {
      this.loadingShipments = true;
      getRequest(
        "/shipment/institution",
        `id=${this.$store.getters.institutionId}`,
      )
        .then((response) => {
          this.shipments = response.shipments;
        })
        .catch(() => {})
        .finally(() => {
          this.loadingShipments = false;
        });
    },
    getQualities() {
      this.loadingQualities = true;
      getRequest("/quality")
        .then((response) => {
          this.qualities = response.qualities;
        })
        .catch(() => {})
        .finally(() => {
          this.loadingQualities = false;
        });
    },
    getWarranties() {
      this.loadingWarranties = true;
      getRequest("/warranty")
        .then((response) => {
          this.warranties = response.warranties;
        })
        .catch(() => {})
        .finally(() => {
          this.loadingWarranties = false;
        });
    },
  },
};
</script>
